import { Injectable, signal } from '@angular/core'

import { LoggerService } from '@definitions/logging'
import { LoggingLevel } from '@enums/logging'

@Injectable({
	providedIn: 'root',
})
export class ConsoleLoggerService implements LoggerService {
	readonly #userId = signal<string | null>(null)
	readonly #sessionId = signal<string | null>(null)

	debug(message: string, context?: Record<string, any>): void {
		this.#log(LoggingLevel.Debug, message, context)
	}

	info(message: string, context?: Record<string, any>): void {
		this.#log(LoggingLevel.Info, message, context)
	}

	warn(message: string, context?: Record<string, any>): void {
		this.#log(LoggingLevel.Warn, message, context)
	}

	error(message: string, error?: Error, context?: Record<string, any>): void {
		this.#log(LoggingLevel.Error, message, context, error)
	}

	setUser(userId: string): void {
		this.#userId.set(userId)
	}

	setSession(sessionId: string): void {
		this.#sessionId.set(sessionId)
	}

	#log(level: LoggingLevel, message: string, context?: Record<string, any>, error?: Error): void {
		const userId = this.#userId()
		const sessionId = this.#sessionId()
		const timestamp = new Date().toISOString()
		const logData: any = {
			timestamp,
			level: level.toUpperCase(),
			message,
			...context,
		}

		if (userId) logData.userId = userId

		if (sessionId) logData.sessionId = sessionId

		if (error) {
			logData.error = {
				name: error.name,
				message: error.message,
				stack: error.stack,
			}
		}

		if (level === LoggingLevel.Debug) {
			console.debug('�� DEBUG:', logData)
		} else if (level === LoggingLevel.Info) {
			console.info('ℹ️ INFO:', logData)
		} else if (level === LoggingLevel.Warn) {
			console.warn('⚠️ WARN:', logData)
		} else if (level === LoggingLevel.Error) {
			console.error('❌ ERROR:', logData)
		}
	}
}
